// extracted by mini-css-extract-plugin
export default {"wrapper":"FlatAvailableFilter_wrapper__8gWwc","filterButton":"FlatAvailableFilter_filterButton__p7aBk","active":"FlatAvailableFilter_active__XhN0L"};